/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.7.0-nightly.2026.9.19",
    versionName: "0.7.0-nightly.2026.9.19",
    versionChannel: "nightly",
    buildDate: "2026-09-19T00:16:21.712Z",
    commitHash: "28f2fccd19db20fe9797097e24aa1c83d815c398",
};
